import { Partial } from '@40seas/entities/common';
import { FundsMatching } from './funds.matching.entity';

export class UpdateFundsMatchingDto extends Partial(FundsMatching) {}
